export default "__VITE_ASSET__4in_NRra__"